"use strict";

exports.__esModule = true;
exports.COVER_TYPE_NONE = exports.COVER_TYPE_IMAGE = exports.COVER_TYPE_COLOR = void 0;
var COVER_TYPE_COLOR = 'color';
exports.COVER_TYPE_COLOR = COVER_TYPE_COLOR;
var COVER_TYPE_IMAGE = 'image';
exports.COVER_TYPE_IMAGE = COVER_TYPE_IMAGE;
var COVER_TYPE_NONE = 'none';
exports.COVER_TYPE_NONE = COVER_TYPE_NONE;